import React from "react";

const FromToRangeInput = ({
  fromLabel,
  toLabel,
  InputWidth,
  mainLabel,
  mainContainerClass,
  innerContainerClass,
  onMinChange,
  onMaxChange,
  fromValue,
  toValue,
  isDecimal = false,
}) => {
  const handleInputChange = (handler) => (e) => {
    const value = e.target.value;
    if (!isDecimal || value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
      handler(e);
    }
  };

  return (
    <div className={mainContainerClass || ""}>
      <label className="filter-main-label">{mainLabel || "Label"}</label>
      <div className={`filter-bg-container ${innerContainerClass || ""}`}>
        <input
          type={isDecimal ? "number" : "text"}
          step={isDecimal ? "0.01" : undefined}
          placeholder={fromLabel || "From"}
          style={{
            width: InputWidth || "100%",
          }}
          onChange={handleInputChange(onMinChange)}
          value={fromValue || ""}
        />
        <input
          type={isDecimal ? "number" : "text"}
          step={isDecimal ? "0.01" : undefined}
          placeholder={toLabel || "To"}
          style={{
            width: InputWidth || "100%",
          }}
          onChange={handleInputChange(onMaxChange)}
          value={toValue || ""}
        />
      </div>
    </div>
  );
};

export default FromToRangeInput;
